import React, { useState } from 'react'
import { NavLink, Navigate } from 'react-router-dom'
import { Button, Form, Grid, Segment, Message } from 'semantic-ui-react'

function Signup() {

    const handleSubmit = async (e) => {
        e.preventDefault()
    }

    return (
        <Grid textAlign='center'>
            <Grid.Column style={{ maxWidth: 450 }}>
                signup
            </Grid.Column>
        </Grid>
    )
}

export default Signup